<template>
    <ScrollingDocument
        class="pdf-preview"
        @pages-fetch="onPagesFetch"
        v-bind="{pages, pageCount, currentPage}"
        :class="{'hidden': isHidden}"
    >
        <PDFThumbnail
            slot-scope="{page, isElementVisible, isPageFocused, isElementFocused}"
            v-bind="{scale, page, isElementVisible, isPageFocused, isElementFocused}"
            @thumbnail-rendered="onThumbnailRendered"
            @thumbnail-errored="onThumbnailErrored"
            @page-focus="onPageFocused"
        />
    </ScrollingDocument>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import ScrollingDocument from './ScrollingDocument';
    import PDFThumbnail from './PDFThumbnail';

    export default {
        name: 'PDFPreview',
        components: {
            ScrollingDocument,
            PDFThumbnail,
        },
        data() {
            return {
                isHidden: true
            }
        },
        props: {
            pages: {
                required: true,
            },
            pageCount: {
                type: Number,
                default: 0,
            },
            scale: {
                type: Number,
                default: 1.0,
            },
            currentPage: {
                type: Number,
                default: 1,
            },
        },
        mounted() {
            EventBus.$on('togglePreviews', () => this.isHidden = !this.isHidden);
        },
        methods: {
            onPagesFetch(currentPage) {
                this.$parent.$emit('pages-fetch', currentPage);
            },
            onPageFocused(pageNumber) {
                this.$parent.$emit('page-focus', pageNumber);
            },
            onThumbnailRendered(payload) {
                this.$el.dispatchEvent(new Event('scroll'));
                this.$parent.$emit('thumbnail-rendered', payload);
            },
            onThumbnailErrored(payload) {
                this.$parent.$emit('thumbnail-errored', payload);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .pdf-preview {
        position: absolute;
        overflow: auto;
        z-index: 1;
        padding: 2em 0;
        top: 0;
        left: 0;
        bottom: 0;
        display: block;
        width: 15%;
        background-color: rgb(27, 30, 31);
        -webkit-transition: -webkit-transform .5s ease;
        transition: -webkit-transform .5s ease;
        transition: transform .5s ease;
        transition: transform .5s ease, -webkit-transform .5s ease;
        -webkit-transform: translateX(0);
        transform: translateX(0);
        &.hidden {
            transform: translateX(-100%);
        }
    }

    .scrolling-page {
        margin-bottom: 1em;
    }

    @media print {
        .pdf-preview {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/pdfViewer/PDFPreview.vue